// extracted by mini-css-extract-plugin
export default {"headercontainer":"Adminheader_headercontainer__teq6W","leftcontent":"Adminheader_leftcontent__BGPYM","admininfo":"Adminheader_admininfo__LwMhO"};